import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import flechaAvanzar from "../assets/right-arrow.svg";
import puntitos from "../assets/puntitos.svg";
import ScenarioBar from "../components/ScenarioBar";
import { useLang } from "../translations/i18n";
import { ROUTES } from "../utils/constants";
import { updateStats, updateTimer } from "../utils/helpers";
import { modalWait } from "../utils/logger";
import oncommit from "../assets/hemmexus.png";
import avatarVideo from "../assets/avatares/mute-red.webm";
import avatarVideoMp4 from "../assets/avatares/mute-red.mp4";

import { useVideoWithSound } from "../hooks/useVideoWithSound";

function GameIntroduction({ intl }) {
	const lang = useLang();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [isCompleted, setIsCompleted] = useState(false);
	const [loading, setLoading] = useState(false);
	const { state } = useLocation();
	const { completed } = state || false;

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});


	const activeScenario = 0;

	const handleStartGame = (e) => {
		e.preventDefault();
		if (loading) return;
    	setLoading(true);

		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME2, {
					state: {
						activeScenario: 1,
					},
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							className="mt-4"
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "50%",
							}}
						/>
						<video
							ref={videoRef}
							autoPlay
							playsInline
							preload="auto"
							muted
							loop
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end bg-blur h-100 px-5">
						<div className="recuadro-white mb-3 w-100">
							<h3 className="txtTitulos txt-red mb-4">
								Bienvenidos a Sinfonía Hemmexus
							</h3>
							<p className="txtTexto1 black mb-4">
								El objetivo es resolver los desafíos para recuperar los "acordes" de cada una de las salas y reconstruir la sinfonía Hemmexus de manera adecuada.
							</p>
							<p className="txtTexto1 black mb-4">
								Se busca integrar la evidencia científica para la atención de pacientes con mieloma múltiple, aplicar las guías clínicas actualizadas para la toma de decisiones y trabajar de forma colaborativa en escenarios de alta presión para brindar el mejor abordaje en un paciente con esta enfermedad.
							</p>
							<p className="txtTexto1 black mb-4">
								A lo largo del caso deberán resolver pruebas y tomar decisiones que evaluarán su capacidad de análisis, así como su desempeño en el trabajo colaborativo.
							</p>
							<p className="txtTexto1 black mb-4">
								Este caso es totalmente ficticio y ha sido creado con fines educativos. Todos los contenidos presentados corresponden a un caso clínico del autor.
							</p>
						</div>
						<div className="d-flex justify-content-end align-items-center">
							<div className="txtBotones me-3">
								Siguiente
							</div>
							<button
								onClick={handleStartGame}
								className="btn-main btn-progress"
								data-loading={loading ? "true" : "false"}
								style={{ width: 80, height: 80, borderRadius: "50%" }}
								aria-busy={loading}
							>
								<img
								src={flechaAvanzar}
								alt="Siguiente"
								style={{ maxWidth: "40px" }}
								/>
							</button>              
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}


export default injectIntl(GameIntroduction);
